var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tinymce-editor" },
    [
      _vm.editorLoading
        ? _c("div", { staticClass: "tinymce-loading-mask" }, [
            _c("div", { staticClass: "tinymce-loading-text" }, [
              _vm._v("Loading editor..."),
            ]),
          ])
        : _vm._e(),
      _c("editor", {
        ref: "editorRef",
        attrs: {
          init: _vm.init,
          disabled: _vm.disabled,
          "api-key": _vm.tinymceApiKey,
          "cloud-channel": _vm.tinymceCloudChannel,
        },
        on: { input: _vm.onInput },
        model: {
          value: _vm.editorValue,
          callback: function ($$v) {
            _vm.editorValue = $$v
          },
          expression: "editorValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }